import React from 'react'
import { Col, Row } from 'reactstrap'
import RoadBookingSearchResult from './search/RoadBookingSearchResult'
import RoadBookingSearch from './search/RoadBookingSearch'

const RoundTrip = () => (
  <div>
    <RoadBookingSearch />
    <Row>
      <Col>
        <RoadBookingSearchResult />
      </Col>
    </Row>
  </div>
)
export default RoundTrip
